import { BaseSyntheticEvent, ChangeEventHandler } from 'react';
import PropTypes from 'prop-types';

import { isObjectEmpty } from '@/utils/comparisonUtils';
import { getValueId } from '@/utils/categUtils';

import CheckboxV2 from '@/components/common/CheckboxV2';

import styles from './CheckboxFilter.module.scss';

const CheckboxFilter = ({ filter, onChange, selectedValue = {}, className, isModalFilter = false, reversed = false }) => {
  const { nameId, nbByValue } = filter;

  const handleOnChange = (event: BaseSyntheticEvent<ChangeEventHandler<HTMLInputElement>, HTMLInputElement, HTMLInputElement>) => {
    const value = event?.target?.value;
    const check = event?.target.checked;

    onChange({
      nameId,
      valueId: check ? getValueId(value, nbByValue) : undefined,
      value: check ? value : undefined,
      check
    });
  };

  const computedClassName = [
    styles.container,
    className,
    isModalFilter && styles['modal-filter'],
    reversed && styles.reversed
  ].filter(Boolean).join(' ');

  return nbByValue?.length > 0 ? (
    <div className={computedClassName} data-rbf="checkbox-filter" data-test-id="checkbox-filter">
      {nbByValue.map(({ valueId, value, nb }) => {
        const key = `${nameId}-${valueId}`;

        const isChecked = selectedValue[key] === value;

        return (
          <CheckboxV2
            key={key}
            id={key}
            className={styles.checkbox}
            name={nameId}
            value={value}
            label={`${value} (${nb})`}
            checked={isChecked}
            onChange={handleOnChange}
            disabled={!isChecked && !isObjectEmpty(selectedValue)}
          />
        );
      })}
    </div>
  ) : null;
};

CheckboxFilter.propTypes = {
  filter: PropTypes.shape({
    nameId: PropTypes.string,
    nbByValue: PropTypes.array
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  selectedValue: PropTypes.object
};

export default CheckboxFilter;
